// src/pages/admin/HeroGrids.jsx
import { useEffect, useState } from 'react'
import {
  addHeroGrid,
  deleteHeroGrid,
  listHeroGrids,
  updateHeroGrid,
} from '../../lib/heroGrids'

export default function HeroGridsAdmin() {
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(true)
  const [editing, setEditing] = useState(null)
  const [form, setForm] = useState({})

  async function load() {
    setLoading(true)
    const rows = await listHeroGrids()
    setItems(rows)
    setLoading(false)
  }

  useEffect(() => {
    load()
  }, [])

  function startNew() {
    setEditing(null)
    setForm({
      mainTitle: '',
      mainSubtitle: '',
      mainImageUrl: '',
      mainHref: '/catalog',
      mainCtaLabel: 'Learn more',
      mainBgColor: '#006d38',

      tile1Title: '',
      tile1Subtitle: '',
      tile1ImageUrl: '',
      tile1Href: '/catalog',

      tile2Title: '',
      tile2Subtitle: '',
      tile2ImageUrl: '',
      tile2Href: '/catalog',

      tile3Title: '',
      tile3Subtitle: '',
      tile3ImageUrl: '',
      tile3Href: '/catalog',

      tile4Title: '',
      tile4Subtitle: '',
      tile4ImageUrl: '',
      tile4Href: '/catalog',

      position: items.length + 1,
      isActive: true,
    })
  }

  function startEdit(item) {
    setEditing(item)
    setForm({
      ...item,
      position: item.position ?? 1,
      isActive: item.isActive ?? true,
    })
  }

  function handleChange(e) {
    const { name, value, type, checked } = e.target
    setForm(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }))
  }

  async function handleSubmit(e) {
    e.preventDefault()
    if (editing) {
      await updateHeroGrid(editing.id, {
        ...form,
        position: Number(form.position) || 1,
      })
    } else {
      await addHeroGrid({
        ...form,
        position: Number(form.position) || 1,
      })
    }
    setEditing(null)
    setForm({})
    await load()
  }

  async function handleDelete(id) {
    if (!window.confirm('Supprimer cette grille de bannières ?')) return
    await deleteHeroGrid(id)
    if (editing && editing.id === id) {
      setEditing(null)
      setForm({})
    }
    await load()
  }

  return (
    <div className="container py-4">
      <h2 className="mb-3">Bannières grille (type Walmart)</h2>

      {/* Liste existante */}
      <div className="mb-4">
        <button className="btn btn-primary btn-sm mb-3" onClick={startNew}>
          + Nouvelle grille de bannières
        </button>

        {loading ? (
          <div>Chargement…</div>
        ) : (
          <table className="table table-sm align-middle">
            <thead>
              <tr>
                <th>#</th>
                <th>Titre principal</th>
                <th>Position</th>
                <th>Actif</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {items.map((it, idx) => (
                <tr key={it.id}>
                  <td>{idx + 1}</td>
                  <td>{it.mainSubtitle || it.mainTitle || <span className="text-muted">Sans titre</span>}</td>
                  <td>{it.position}</td>
                  <td>{it.isActive ? '✅' : '⛔'}</td>
                  <td className="text-end">
                    <button
                      className="btn btn-link btn-sm"
                      onClick={() => startEdit(it)}
                    >
                      Modifier
                    </button>
                    <button
                      className="btn btn-link btn-sm text-danger"
                      onClick={() => handleDelete(it.id)}
                    >
                      Supprimer
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* Formulaire d’édition */}
      {Object.keys(form).length > 0 && (
        <form onSubmit={handleSubmit} className="card-modern p-3">
          <h5 className="mb-3">
            {editing ? 'Modifier la grille' : 'Nouvelle grille de bannières'}
          </h5>

          <div className="row g-3">
            <div className="col-lg-6">
              <h6>Grande bannière (gauche)</h6>
              <div className="mb-2">
                <label className="form-label">Kicker (ligne en petit en haut)</label>
                <input
                  className="form-control"
                  name="mainTitle"
                  value={form.mainTitle}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-2">
                <label className="form-label">Texte principal</label>
                <input
                  className="form-control"
                  name="mainSubtitle"
                  value={form.mainSubtitle}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-2">
                <label className="form-label">Image (URL)</label>
                <input
                  className="form-control"
                  name="mainImageUrl"
                  value={form.mainImageUrl}
                  onChange={handleChange}
                />
              </div>
              <div className="row">
                <div className="col-md-6 mb-2">
                  <label className="form-label">Texte bouton</label>
                  <input
                    className="form-control"
                    name="mainCtaLabel"
                    value={form.mainCtaLabel}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-6 mb-2">
                  <label className="form-label">Lien bouton (href)</label>
                  <input
                    className="form-control"
                    name="mainHref"
                    value={form.mainHref}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="mb-2">
                <label className="form-label">Couleur de fond (hex)</label>
                <input
                  className="form-control"
                  name="mainBgColor"
                  value={form.mainBgColor}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="col-lg-6">
              <h6>Cartes à droite</h6>

              {[1, 2, 3, 4].map(i => (
                <div key={i} className="border rounded-3 p-2 mb-2">
                  <div className="small text-muted mb-1">
                    Carte {i}
                  </div>
                  <div className="mb-1">
                    <input
                      className="form-control form-control-sm"
                      placeholder="Titre"
                      name={`tile${i}Title`}
                      value={form[`tile${i}Title`] || ''}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="mb-1">
                    <input
                      className="form-control form-control-sm"
                      placeholder="Sous-titre"
                      name={`tile${i}Subtitle`}
                      value={form[`tile${i}Subtitle`] || ''}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="mb-1">
                    <input
                      className="form-control form-control-sm"
                      placeholder="Image (URL)"
                      name={`tile${i}ImageUrl`}
                      value={form[`tile${i}ImageUrl`] || ''}
                      onChange={handleChange}
                    />
                  </div>
                  <div>
                    <input
                      className="form-control form-control-sm"
                      placeholder="Lien (href)"
                      name={`tile${i}Href`}
                      value={form[`tile${i}Href`] || ''}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              ))}

              <div className="row mt-2">
                <div className="col-md-4 mb-2">
                  <label className="form-label">Position</label>
                  <input
                    type="number"
                    className="form-control"
                    name="position"
                    value={form.position}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-4 mb-2 d-flex align-items-end">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="isActive"
                      name="isActive"
                      checked={!!form.isActive}
                      onChange={handleChange}
                    />
                    <label className="form-check-label" htmlFor="isActive">
                      Actif
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-3 d-flex justify-content-end gap-2">
            <button
              type="button"
              className="btn btn-light btn-sm"
              onClick={() => {
                setEditing(null)
                setForm({})
              }}
            >
              Annuler
            </button>
            <button type="submit" className="btn btn-primary btn-sm">
              Enregistrer
            </button>
          </div>
        </form>
      )}
    </div>
  )
}
